import React from 'react';

/**
 * The footer under a long table: which slice is on screen, and the way to the
 * next one. Nothing is rendered when everything fits on one page.
 *
 * The list itself stays with the page that owns it — this only draws the
 * controls, so a table can keep whatever filtering and sorting it already has.
 */
export default function Pagination({ page, pageCount, from, to, total, noun = 'rows', onChange }) {
  if (pageCount <= 1) return null;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: 12, padding: '12px 4px 2px', borderTop: '1px solid var(--border, #e5e7eb)',
      marginTop: 8, fontSize: 13, color: 'var(--text-muted, #667085)',
    }}>
      <span>{from}–{to} of {total} {noun}</span>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        <button className="btn btn-sm" onClick={() => onChange(page - 1)} disabled={page <= 1}>
          Previous
        </button>
        <span>Page {page} of {pageCount}</span>
        <button className="btn btn-sm" onClick={() => onChange(page + 1)} disabled={page >= pageCount}>
          Next
        </button>
      </span>
    </div>
  );
}

/**
 * Which slice of a list belongs on the current page.
 *
 * A filter can shorten the list while the viewer sits past the end of it, so
 * the page is clamped here rather than by every caller.
 */
export function pageSlice(items, page, perPage = 10) {
  const pageCount = Math.max(1, Math.ceil(items.length / perPage));
  const current = Math.min(Math.max(1, page), pageCount);
  const first = (current - 1) * perPage;
  const shown = items.slice(first, first + perPage);
  return { shown, page: current, pageCount, from: first + 1, to: first + shown.length, total: items.length };
}
